import { NgModule }            from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { ProfileModalComponent } from "./profile-modal/profile-component";
import { CompanyLoginComponent } from "./company-login/company-login";
import { CompanyRegisterComponent } from "./company-login/company-register";
import { GameUserLoginModalComponent }   from './userlogin/game-userlogin-component';
import {TranslateModule} from "../../translate-module";
import { TextMaskModule } from 'angular2-text-mask';
import { CheckVideoComponent } from "./checkvideo/checkvideo-component";
import { CardModalComponent } from "./card-modal/card-component";
import { TransactionHistoryModalComponent } from "./transactionHistory/transaction-history-component";
import { AvatarPageComponent } from "./avatar/avatar-page-component";

@NgModule({
    imports : [
        ReactiveFormsModule,
        CommonModule,
        TranslateModule,
        TextMaskModule,
    ],
    declarations : [
        GameUserLoginModalComponent,
        CompanyLoginComponent,
        CompanyRegisterComponent,
        AvatarPageComponent,
        ProfileModalComponent,
        CheckVideoComponent,
        CardModalComponent,
        TransactionHistoryModalComponent
    ],
    exports:[
        GameUserLoginModalComponent,
        AvatarPageComponent,
        ProfileModalComponent,
        CheckVideoComponent,
        CardModalComponent,
        TransactionHistoryModalComponent
    ],
    providers : [
    ]
})
export class EasyLoginModule {}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+easylogin/easylogin.module.ts